module.exports = __webpack_public_path__ + "img/4_l_uk.b1cc23ea.svg";